import styled from 'styled-components'

export default styled.div`
  margin-bottom: 0.5rem;
`



// WEBPACK FOOTER //
// ./src/components/InputGroup/index.js